import { ESimFilters } from '../constants/esim';

const ESIM_PRODUTCS_ROOT = ['ESimProducts'];

export const eSimProductsQueries = {
  all: ESIM_PRODUTCS_ROOT,
  eSims: [...ESIM_PRODUTCS_ROOT, 'esims'],
  list: (filters: ESimFilters) => {
    return [...eSimProductsQueries.eSims, filters];
  },
  profiles: [...ESIM_PRODUTCS_ROOT, 'profiles'],
  profilesList: (props: { eid: string }) => {
    return [...eSimProductsQueries.profiles, props];
  },
  esim: (props: { eid: string }) => [...ESIM_PRODUTCS_ROOT, 'single', props],
};
